import { motion } from "framer-motion";
import React from "react";
import {
  InitiativeWithProgressOutput,
  UnitEntity,
} from "../../../generated/graphql";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./initiative-item.scss";
import { getFontSize } from "../../../AppFont";
import classNames from "classnames";
import { CONSTANTS } from "../../../constants";
import play from "./play.png";
import refresh from "./refresh.png";


interface Props {
  initiative: UnitEntity;
  onClick: Function;
  allInitiatives?: InitiativeWithProgressOutput[];
  hideStartButton?: boolean;
  progress?: number;
  noLeftMargin?: boolean;
  makeBold?: boolean;
  showProgressBar: boolean;
  packageName?: string;
}

const INITIATIVE_ICON_SRC =
  "https://cdn.picpng.com/icon/play-icon-free-wallpaper-vector-65968.png";

export const InitiativePackageItem = (props: Props) => {
  const { initiative, packageName } = props;
  let buttonText: string;

  const childInitiatives = (props.allInitiatives || []).filter((ai) => {
    return (
      ai.unit.is_private === 1 && ai.unit.parent_unit == +props.initiative.id
    );
  });

  let showButton = true;

  let allChildInitiativesCompleted = true;
  childInitiatives.forEach((i) => {
    if (i.progress < 100) {
      allChildInitiativesCompleted = false;
    }
  });

  if (!allChildInitiativesCompleted) {
    showButton = false;
  }

  if ((props.progress || 0) >= 100 && props.initiative.is_private) {
    showButton = false;
  }

  if (props.progress === 0) {
    buttonText = "START";
  } else if (props.progress! >= 100 && allChildInitiativesCompleted) {
    buttonText = "ReView";
  } else {
    buttonText = "RESUME";
  }

  return (
    <motion.div
      onClick={() => (showButton ? props.onClick() : null)}
      layoutId={`initiative-${initiative.id}`}
      className="initiative-item"
    >
      <div className="initiative-details">
        {props.showProgressBar && (
          <div>
            {+props.progress! === 100 && <div className="">
              {/* <img src="https://static.vecteezy.com/system/resources/thumbnails/041/643/571/small_2x/repeat-3d-icon-illustration-png.png"
                className="h-8 w-8"
              /> */}
              <img src={refresh}
                className="h-6 w-6 opacity-80 ml-1"
              />
              {/* <RefreshIcon className="h-8 w-8 text-[#2767ce]" /> */}
            </div>}
            {+props.progress! < 100 && <div className="initiative-icon opacity-80">
              <CircularProgressbarWithChildren
                styles={{
                  path: {
                    stroke: "#2767ce",
                  },
                }}
                value={props.progress!}
                strokeWidth={12}
              >
                <div>
                  <img src={play} className="w-3 h-3 ml-0.5" />
                </div>
              </CircularProgressbarWithChildren>
            </div>}
          </div>
        )}

        <div
          style={{
            fontSize: getFontSize(),
          }}
          className={classNames(
            props.makeBold ? "font-bold" : "",
            "pl-3",
            // props.noLeftMargin ? "" : "px-3",
          )}
        >
          <div className="inline-block mr-2">
            {initiative.is_private === 1
              ? initiative.reassigned_display_name
              : initiative.name}
          </div>

          {packageName !== CONSTANTS.INITIATIVES_WITHOUT_PACKAGE_TITLE && (
            <div className="text-xs border p-1 rounded-md border-blue-500 inline-block text-blue-500 px-2">
              {packageName}
            </div>
          )}
        </div>
      </div>
      {/* {showButton && (
        <div
          className="initiative-button"
          style={{
            opacity: props.hideStartButton ? 0 : 1,
            fontSize: getFontSize(),
          }}
        >
          <div className="learn-button">{buttonText}</div>
        </div>
      )} */}
    </motion.div>
  );
};
